import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext'; 

window.addEventListener("error", function (event) {
  if (event.message === "Script error.") {
    console.warn("⚠️ Suppressed cross-origin script error");
    event.preventDefault(); // Optionally suppress browser's default behavior
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ✅ Wrap App in AuthProvider */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
